import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

const apiPrefix = '/user-mgmt/v1/';
const routes = {
    businessEntities: () => apiPrefix + `business-entities`,
    bookingsSync: () => apiPrefix + `trigger-booking-sync`,
    invoicesSync: () => apiPrefix + `trigger-invoice-sync`,
    soaSync: () => apiPrefix + `trigger-soa-sync`,
};

@Injectable({
    providedIn: 'root'
})
export class CustomerDataSyncService {

    constructor(private http: HttpClient) {
    }

    getBusinessEntities() {
        const $businessEntities: Observable<any> = this.http
            .get(routes.businessEntities())
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $businessEntities;
    }

    syncBookingsData(businessEntityId: any) {
        const $bookingsSync = this.http
            .post(routes.bookingsSync(), null, {
                params: {
                    businessEntityId
                }
            })
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $bookingsSync;
    }

    syncInvoicesData(businessEntityId: any) {
        const $invoicesSync = this.http
            .post(routes.invoicesSync(), null, {
                params: {
                    businessEntityId
                }
            })
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $invoicesSync;
    }

    syncSOAData(businessEntityId: any) {
        const $soaSync = this.http
            .post(routes.soaSync(), null, {
                params: {
                    businessEntityId
                }
            })
            // .toPromise();
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $soaSync;
    }

    createNewBusinessEntity(locationGid: any) {
        const $location: Observable<any> = this.http
            .post(routes.businessEntities(), null, {
                params: {
                    locationGid
                }
            })
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $location;
    }
}
